import { HStack, Text, VStack } from 'ui_2';
import { AccountAndBalance } from '../AccountAndBalance';
import puzzleIcon from '../../../public/assets/icon-34.png';
import { useArcadeStoreState } from '@src/hooks/useArcadeStoreState';
import { FileRouteTypes, Link } from '@tanstack/react-router';
import { Route as index_route } from '@routes/index';
import { BiChevronLeft } from 'react-icons/bi';
import { ReactNode, useCallback } from 'react';
import { useViewTransition } from '@src/hooks/useViewTransition';

type Props = {
  title?: string;
  backRoute?: FileRouteTypes['to'];
  onBack?: () => void;
  isHomePage?: boolean;
  rightElement?: ReactNode;
  showAccountAndBalance?: boolean;
};

const headerXPadding = `px-4 sm:px-8 md:px-16`;
const headerYPadding = `py-4 md:py-8`;

export const ArcadeStoreHeader = ({
  title,
  backRoute,
  onBack,
  isHomePage = false,
  rightElement,
  showAccountAndBalance = true,
}: Props) => {
  const { isPuzzleWalletWebview } = useArcadeStoreState();
  const { slideRightFullPage } = useViewTransition();

  const BackButton = useCallback(() => {
    if (backRoute) {
      return (
        <Link
          to={backRoute}
          onClick={onBack}
          viewTransition={slideRightFullPage}
          className='-translate-x-[7.5px]'
        >
          <BiChevronLeft size={24} className={'text-black'} />
        </Link>
      );
    }
  }, [backRoute, onBack, slideRightFullPage]);

  return (
    <VStack className='sticky top-0 z-50 w-full gap-4 bg-white text-left'>
      {showAccountAndBalance && (
        <HStack
          className={`w-full items-center gap-2 border-b border-gray-200 ${headerXPadding} ${headerYPadding}`}
        >
          {isPuzzleWalletWebview === false && (
            <>
              <Link to={index_route.to}>
                <img
                  src={puzzleIcon}
                  className='h-[42px] w-[42px] object-contain'
                  alt='Puzzle Wallet Logo'
                />
              </Link>
              <Text font='bold-xl' className='hidden lg:block'>
                Puzzle Arcade Store
              </Text>
              <Text
                font='bold-md'
                className='max-lg:hidden hidden sm:block lg:hidden'
              >
                Arcade Store
              </Text>
            </>
          )}
          {isPuzzleWalletWebview === true && isHomePage && (
            <>
              <Text font='bold-md'>Store</Text>
            </>
          )}
          {isPuzzleWalletWebview === true && <BackButton />}
          <HStack className='flex-grow' />
          <AccountAndBalance />
        </HStack>
      )}
      {isPuzzleWalletWebview === true && title && (
        <HStack className={`w-full ${headerXPadding}`}>
          <Text font='bold-sm'>{title}</Text>
          <HStack className='flex-grow' />
          {rightElement}
        </HStack>
      )}
      {isPuzzleWalletWebview === false && (backRoute || title) && (
        <HStack className={`items-center gap-2 ${headerXPadding}`}>
          <BackButton />
          {title && (
            <>
              <Text font='bold-md' family='atak' className='hidden md:block'>
                {title}
              </Text>
              <Text font='bold-xs' family='atak' className='block md:hidden'>
                {title}
              </Text>
            </>
          )}
          <HStack className='flex-grow' />
          {rightElement}
        </HStack>
      )}
    </VStack>
  );
};
